const independentTheme = {
    key: "independent",
    text: "#1d2024",
    textStrong: "#3c454d",
    muted: "#66707a",
    mutedStrong: "#59636e",
    border: "#d8dde2",
    surface: "#ffffff",
    surfaceAlt: "#f7f9fa",
    headerFill: "#f1f4f6",
    primary: "#072776",
    primarySoft: "#e6f1fb",
    secondary: "#05cc02",
    secondarySoft: "#e1f5ee",
    accent: "#05cc02",
    accentSoft: "#e1f5ee",
    action: "#072776",
    danger: "#a32d2d",
    dangerSoft: "#faece7",
    warning: "#633806",
    warningSoft: "#faeeda"
};

const castTheme = {
    key: "cast",
    text: "#231f20",
    textStrong: "#231f20",
    muted: "#66707a",
    mutedStrong: "#59636e",
    border: "#d8dde2",
    surface: "#ffffff",
    surfaceAlt: "#f7f9fa",
    headerFill: "#f1f4f6",
    accent: "#f58220",
    primarySoft: "#fff0e3",
    secondary: "#99ca45",
    secondarySoft: "#eff7df",
    primary: "#27aae1",
    accentSoft: "#e4f5fc",
    action: "#f58220",
    danger: "#a32d2d",
    dangerSoft: "#faece7",
    warning: "#633806",
    warningSoft: "#faeeda"
};

export const dashboardThemes = {
    independent: independentTheme,
    cast: castTheme
};

export const resolveDashboardTheme = ({ instanceType, independent } = {}) => {
    const isCast = Boolean(instanceType && independent && instanceType !== independent);
    return isCast ? dashboardThemes.cast : dashboardThemes.independent;
};

export const getDashboardThemeCssVariables = (theme = dashboardThemes.independent) => ({
    "--dashboard-text": theme.text,
    "--dashboard-text-strong": theme.textStrong,
    "--dashboard-muted": theme.muted,
    "--dashboard-muted-strong": theme.mutedStrong,
    "--dashboard-border": theme.border,
    "--dashboard-surface": theme.surface,
    "--dashboard-surface-alt": theme.surfaceAlt,
    "--dashboard-header-fill": theme.headerFill,
    "--dashboard-primary": theme.primary,
    "--dashboard-primary-soft": theme.primarySoft,
    "--dashboard-secondary": theme.secondary,
    "--dashboard-secondary-soft": theme.secondarySoft,
    "--dashboard-accent": theme.accent,
    "--dashboard-accent-soft": theme.accentSoft,
    "--dashboard-action": theme.action,
    "--dashboard-danger": theme.danger,
    "--dashboard-danger-soft": theme.dangerSoft,
    "--dashboard-warning": theme.warning,
    "--dashboard-warning-soft": theme.warningSoft
});

export const getDashboardPdfColors = (theme = dashboardThemes.independent) => ({
    text: theme.text,
    muted: theme.muted,
    border: theme.border,
    headerFill: theme.headerFill,
    surfaceAlt: theme.surfaceAlt,
    primary: theme.primary,
    primarySoft: theme.primarySoft,
    secondary: theme.secondary,
    secondarySoft: theme.secondarySoft,
    accent: theme.accent,
    accentSoft: theme.accentSoft,
    danger: theme.danger,
    dangerSoft: theme.dangerSoft
});
